import React, { useEffect, useState} from 'react';
import { Copy } from "lucide-react"
import { appStore } from "lib/state"
import { cn, inspect, queryTools } from "lib/utils"
import { SelectField } from "lib/components"
import { Forms } from "lib/components/forms"
import { useApiData } from "lib/units/apidata"
const { apiDataTypes } = inspect


export default function ApiDatapointEditor({ onItemSelect, closeFn }:{ onItemSelect:any; closeFn:any }){

  const { store, AppStore }:any = appStore() 
  const { update }:any = AppStore 

  const [ message, setMessage ] = useState<any>({ type: "success", text: "" })
  const [ apiFormData, setApiFormData ] = useState<any>()

  const buttonClasses = "w-full bg-transparent text-sm text-neutral-300 border border-solid border-slate-700 px-2 py-1"

  const saveFn = queryTools.resource.save(["apidata.all"], () => update("ui.toast", { id: Date.now(), visible: true, type: "success", message: "Api Data Saved Successfully" }))
  
  async function handleApiDataSave(){
    saveFn.mutate({ resource: "apidata", data: apiFormData })
  }

  const handleInputChange = (e:any) => setApiFormData({ ...apiFormData, [e.target.name]: e.target.value })
  
  const handleFormSubmit = (e:any) => {
    e.preventDefault()
    handleApiDataSave()
  }

  function handleSelectClick(alsoClose:boolean = false){
    onItemSelect(store.actives.apidata)
    setMessage({ type: "success", text: "Item copied and added to staging area." })
    if( alsoClose ) {
      closeFn()
    }
  }

  useEffect(() => {
    if( !apiFormData ){
      if( store.actives.apidata ){
        console.log("new active item", store.actives.apidata._id)
        setApiFormData(store.actives.apidata)
      } else {
        setApiFormData({ type: "", hiddenType: "", placeholder: "", useInContent: "", description: "" })
      }
    }
  },[store.actives.apidata, apiFormData])

  useEffect(() => {
    if( message.text.length ){
      const timeout = setTimeout(() => {
        setMessage({ type: "success", text: "" })
      }, 5000)
      return () => clearTimeout(timeout)
    }
  },[message])

  if( !apiFormData ) return <></>
  return (
    <div className="w-full h-full flex flex-col gap-6">
      <Forms.Form onSubmit={handleFormSubmit}>
        {/* Row with Api Datapoint Name and Abbreviation  */} 

        <div className="w-full flex justify-start items-center px-5 gap-6">
          <div className="w-full flex flex-col gap-2">
            <span className="text-sm uppercase text-neutral-500 border-b border-solid border-neutral-500">Api Datapoint Name</span>
            <Forms.FieldGroup name="label" required={true}>
              <Forms.InputField 
                name="label" 
                className="" 
                value={apiFormData?.label || ""}
                onChange={handleInputChange}
              />
            </Forms.FieldGroup>
            {/* <span className="text-neutral-100 text-sm">{ store.actives.apidata?.label }</span> */}
          </div>

          <div className="w-full flex flex-col gap-2">
            <span className="text-sm uppercase text-neutral-500 border-b border-solid border-neutral-500">Abbreviation</span>
            <Forms.FieldGroup name="placeholder" required={true}>
              <Forms.InputField 
                name="placeholder" 
                className="" 
                value={apiFormData?.placeholder || ""}
                onChange={handleInputChange}
              />
            </Forms.FieldGroup>
          </div>
        </div>


        {/* Full Api Path  */}

        <div className="w-full flex flex-col px-5 gap-2 mb-5">
          <div className="w-full flex justify-between items-center pr-1 border-b border-solid border-neutral-500">
            <span className="text-sm uppercase text-neutral-500">Full Api Path</span>
            {/* <Copy className="w-4 h-4 stroke-1 cursor-pointer" onClick={() => console.log("copied")} /> */}
          </div>
          <span className="text-neutral-100 text-sm">{ store.actives.apidata?.path }</span>
        </div>


        {/* row with Presented Data Type and Hidden Data Type  */}

        <div className="w-full flex flex-col px-5 gap-4">
          <div className="w-full flex justify-start items-start gap-8">
            <div className="w-full flex flex-col gap-2">
              <span className="text-sm uppercase text-neutral-500 border-b border-solid border-neutral-500">Presented Data Type</span>
              <Forms.FieldGroup name="type">
                <Forms.Select 
                  name="type" 
                  className="" 
                  value={apiFormData?.type || ""} 
                  onChange={handleInputChange} 
                  options={ apiDataTypes.map( (type:string) => ({ label: type, value: type }) ) }
                />
              </Forms.FieldGroup>
            </div>

            <div className="w-full flex flex-col gap-2">
              <span className="text-sm uppercase text-neutral-500 border-b border-solid border-neutral-500">Actual Data Type</span>
              <Forms.FieldGroup name="hiddenType">
                <Forms.Select 
                  name="hiddenType" 
                  className="" 
                  value={apiFormData.hiddenType} 
                  onChange={handleInputChange} 
                  options={ apiDataTypes.map( (type:string) => ({ label: type, value: type }) ) }
                />
              </Forms.FieldGroup>
            </div>
          </div>

          {/* <div className="w-full *:text-neutral-500">
            <p className="text-xs mt-[-1rem] mb-4">In many cases the data type which is presented by the API is a string, but that string represents a different kind of data. When we make comparisons, we try to do so on the  underlying data type as often as possible.</p>
          </div> */}
        </div>


        {/* allow this data element to have a placeholder & also dictate formatting  */}
        <div className="w-full flex justify-start items-start gap-8 mt-3 px-5">
          <div className="w-5/12 flex flex-col gap-2">
            <span className="text-sm uppercase text-neutral-500 border-b border-solid border-neutral-500">Placeholder?</span>
              <Forms.FieldGroup name="useInContent">
                <Forms.Select 
                  name="useInContent" 
                  className="" 
                  value={apiFormData.useInContent} 
                  onChange={(e:any) => setApiFormData({ ...apiFormData, [e.target.name]: e.target.value === "true" ? true : false })} 
                  options={[ { label: "Yes", value: "true" }, { label: "No", value: "false" }]} 
                />
              </Forms.FieldGroup>
          </div>
          <div className="w-7/12 flex flex-col gap-2">
            <span className="text-sm uppercase text-neutral-500 border-b border-solid border-neutral-500">Format:</span>
              <Forms.FieldGroup name="format">
                <Forms.Select 
                  name="format" 
                  className="" 
                  value={apiFormData.format} 
                  onChange={(e:any) => setApiFormData({ ...apiFormData, [e.target.name]: e.target.value })} 
                  options={[ 
                    { label: "As-Is", value: "" }, 
                    { label: "Currency: Match With Data", value: "currency:match" },
                    { label: "Currency: USD", value: "currency:usd" },
                    { label: "Currency: Euro", value: "currency:euro" },
                    { label: "Date: MM/DD/YYYY", value: "date:MM/DD/YYYY" },
                    { label: "Date: MMMM D, YYYY", value: "date:MMMM D, YYYY" },
                    { label: "Date: MMMM D, YYYY h:mm A", value: "date:MMMM D, YYYY h:mm A" }
                  ]} 
                />
              </Forms.FieldGroup>
          </div>
        </div>


        {/* Description  */} 

        <div className="w-full flex flex-col px-5 gap-2 mt-3">
          <span className="text-sm uppercase text-neutral-500 border-b border-solid border-neutral-500">Description</span>
          <Forms.FieldGroup name="description" required={true}>
            <Forms.Textarea 
              name="description" 
              className="" 
              placeholder="Enter a description for this API data element..."
              value={apiFormData?.description || ""}
              onChange={handleInputChange}
            />
          </Forms.FieldGroup>
        </div>

        <div className="w-full flex flex-col px-5 gap-2">
          <div className="w-full flex justify-end items-center pr-1 mt-[-10px] mb-8">
            <Forms.FormButton onClick={ () => console.log("Save Description") }>
              Save Changes
            </Forms.FormButton>
          </div>
        </div>
        
      </Forms.Form>

      <div className="w-full flex flex-col">
        { onItemSelect !== undefined && ( 
          <div className="w-full flex justify-center items-center gap-2 mb-8">
            <button className={cn(buttonClasses)} onClick={ () => handleSelectClick(false) }>
              Select And Add More
            </button>
            <button className={cn(buttonClasses)} onClick={ () => handleSelectClick(true) }>
              Select And Close
            </button>
          </div>
        )}

        { message.text.length > 0 && (
          <div className="w-full flex justify-center items-center gap-2 mt-[-1rem]">
            <span className={cn("text-sm", message.type === "success" ? "text-green-800" : "text-red-800")}>{ message.text }</span>
          </div>
        )}
      </div>
      
    </div>
  )
}